import validator from '@/vee-validate/validator';
import some from 'lodash/some';
import find from 'lodash/find';

export const validatorMixin = {
  components: {
  },

  props: {
    id: {
      type: String,
      required: true
    },
    validationRules: {
      type: String,
      required: false
    },
    value: {
      type: [String, Number],
      required: false
    }
  },

  data () {
    return {
      errors: null,
      field: null
    };
  },

  computed: {
    hasErrors () {
      return this.validationRules && this.errors.has(this.id);
    },

    statusClasses () {
      return {
        error: this.hasErrors,
        success: this.validationRules && this.value && this.field && this.field.flags.valid
      };
    }
  },

  watch: {
    validationRules (value) {
      if (value) {
        // If field is already attached, detach it first.
        if (some(validator.fields.items, elem => elem.name === this.id)) {
          this.detachValidator();
        }
        this.attachValidator();
      } else {
        this.detachValidator();
      }
    },

    value (value) {
      if (this.validationRules) {
        validator.validate(this.id, value);
      }
    }
  },

  created () {
    if (this.validationRules) {
      this.attachValidator();
    }
  },

  beforeDestroy () {
    if (this.validationRules) {
      this.detachValidator();
    }
  },
  methods: {
    attachValidator () {
      validator.attach(this.id, this.validationRules);
      this.errors = validator.errors;
      this.field = find(validator.fields.items, elem => elem.name === this.id);
    },

    detachValidator () {
      validator.detach(this.id);
    }
  }
};
